module.exports = __webpack_public_path__ + "static/img/coupon-off.3116c612.png";